<template>
  <span class="leaders-nav-link-contents">
    <filter-none-icon :modifiers="iconModifiers" />
    <span class="leaders-nav-link-contents__container">
      <span class="leaders-nav-link-contents__title">{{ title }}</span>
      <videocam-icon v-if="hasVideos" :modifiers="iconModifiers" />
      <img
        v-if="showBoothIcon"
        :src="boothShowIcon"
        width="25"
        height="25"
        class="leaders-icon--videocam"
      >
    </span>
  </span>
</template>

<script>
import FilterNoneIcon from '../../icons/filter-none.vue';
import VideocamIcon from '../../icons/videocam.vue';

export default {
  components: { FilterNoneIcon, VideocamIcon },

  props: {
    title: {
      type: String,
      default: null,
    },
    isActive: {
      type: Boolean,
      default: false,
    },
    hasVideos: {
      type: Boolean,
      default: false,
    },
    booths: {
      type: Array,
      default: () => ([]),
    },
    boothShowIcon: {
      type: String,
      default: '',
    },
  },

  computed: {
    iconModifiers() {
      const mods = [];
      if (this.isActive) mods.push('active');
      return mods;
    },
    showBoothIcon() {
      return this.boothShowIcon && this.booths.length;
    },
  },
};
</script>
